// ./auth.js
export default {
    isAuthenticated() {
      // check if the user is authenticated
      const token = localStorage.getItem('token')
      return token !== null
    }
  }
  
